import React, { Component } from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import Button from '@material-ui/core/Button';
import LaunchIcon from '@material-ui/icons/Launch';
import getIsInMsTeams from 'helpers/getIsInMsTeams';

const styles = theme => {
  return {
    root: {
      fontSize: 14,
      color: theme.palette.grey[600],
      fontWeight: 'bold',
      lineHeight: 1.1,
      letterSpacing: 1.3,
    },
    link: {
      marginRight: theme.spacing(9),
      color: 'inherit',
      [theme.breakpoints.down('sm')]: {
        marginRight: theme.spacing(2),
        marginLeft: theme.spacing(2),
      },
    },
  };
};

class PageFooterNew extends Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
  };

  render() {
    const { classes } = this.props;
    const isInMsTeams = getIsInMsTeams();

    return (
      <div className={classes.root}>
        <Button
          className={classes.link}
          href="https://www.justsift.com/privacy-policy/"
          target="_blank"
          rel="noopener noreferrer"
          startIcon={isInMsTeams ? <LaunchIcon /> : null}
        >
          SECURITY
        </Button>
        <Button
          className={classes.link}
          href="https://www.justsift.com/"
          target="_blank"
          rel="noopener noreferrer"
          startIcon={isInMsTeams ? <LaunchIcon /> : null}
        >
          ABOUT SIFT
        </Button>
      </div>
    );
  }
}

export default withStyles(styles)(PageFooterNew);
